module.exports = __webpack_public_path__ + "img/app_download_qrcode.08a4cbdc.png";